module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_babel-runtime@6.26.0@babel-runtime/core-js/object/assign.js
// module id = 341
// module chunks = 0